<div class="container-fluid">
  <div mat-dialog-title>
    <ng-container *ngIf="data.changeOrder.changeOrder_ID; then editChangeOrder; else newChangeOrder"></ng-container>
    <ng-template #editChangeOrder i18n>Edit Change Order</ng-template>
    <ng-template #newChangeOrder i18n>Add Change Order</ng-template>
  </div>
  <mat-dialog-content>
    <p i18n>A change order will affect the scope of the project.</p>
    <form #changeOrderForm="ngForm" (ngSubmit)="saveChangeOrder(changeOrderForm)">
      <div class="form-group row">
        <label for="changeOrder_Name" class="col-sm-4 col-form-label">
          <span class="warning">* </span><span i18n>Change Order Name</span>
        </label>
        <div class="col-sm-8">
          <input type="tel" class="form-control" name="changeOrder_Name"
                 required
                 [(ngModel)]="data.changeOrder.changeOrder_Name" #changeOrder_Name="ngModel" />
          <div [hidden]="!changeOrderForm.submitted || changeOrder_Name.valid"
               class="alert alert-danger" i18n>
            Provide a change order name
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label for="changeOrder_Comments" class="col-sm-4 col-form-label" i18n>Comments</label>
        <div class="col-sm-8">
          <textarea class="form-control" name="changeOrder_Comments" rows="3"
                    [(ngModel)]="data.changeOrder.changeOrder_Comments" #changeOrder_Comments="ngModel"></textarea>
        </div>
      </div>
      <div class="row">
        <div *ngIf="!isRequesting">
          <button type="submit" mat-button class="mr-2 btn btn-bidit-submit" cdkFocusInitial i18n>Submit</button>
          <button type="button" mat-button (click)="onNoClick()" class="btn btn-bidit-cancel" i18n>Cancel</button>
        </div>
        <app-spinner [isRunning]="isRequesting"></app-spinner>
      </div>
      <div [hidden]="!changeOrderForm.submitted || changeOrderForm.valid"
           class="mt-3 alert alert-danger" i18n>
        Validation issues encountered.  Please review your entered information.
      </div>
    </form>
  </mat-dialog-content>
</div>
